import { defineMessages } from 'react-intl';

export default defineMessages({
    
    basementAreaFinished:{
        id: 'tfpa.quoteandbind.views.Basement Area Finished (Square Feet)  ',
        defaultMessage: 'Basement Area Finished (Square Feet)'
    },
    basementAreaUnfinished:{
        id: 'tfpa.quoteandbind.views.Basement Area Unfinished (Square Feet) ',
        defaultMessage: 'Basement Area Unfinished (Square Feet)'
    },
    foundationType:{
        id: 'tfpa.quoteandbind.views.PleaseChoose',
        defaultMessage: '--Please Select--'
    },
    livingAreaSquareFootage:{
        id: 'tfpa.quoteandbind.views.Living Area Square Footage',
        defaultMessage: 'Living Area Square Footage'
    }, 
    serialNumber: {
       id: 'tfpa.quoteandbind.views.Serial Number',
       defaultMessage: 'Serial Number'
    },
    model:{
       id: 'tfpa.quoteandbind.views.Model',
       defaultMessage: 'Model'
    },
    make: {
       id: 'tfpa.quoteandbind.views.Make',
   defaultMessage: 'Make'
    },
    width: {
       id: 'tfpa.quoteandbind.views.Width',
       defaultMessage: 'Width'
    },
    length: {
       id: 'tfpa.quoteandbind.views.Length',
       defaultMessage: 'Length'        
    },
    no: {
       id: 'tfpa.quoteandbind.tfpa.No',
       defaultMessage: 'No'
    },
    yes: {
       id: 'tfpa.quoteandbind.tfpa.Yes',
       defaultMessage: 'Yes'
    },
    yearBuilt: {
        id: 'tfpa.quoteandbind.views.Year Built',
       defaultMessage: 'Year Built'
    }
});
